<template>
    <div class="register-bg">
        <div class="main-section">
            <h1 class="pl-3 head-title">
                I hated submitting my compliance documents to <br>a bunch of different companies. Now, I simply <br>send my Strata Connex profile link <br>which saves me so much time and effort!
            </h1>

            <div class="d-flex flex-row px-4 my-4">  
                <div><img :src="$root.serverBasePath + '/rev-avatar.png'" /></div>
                <div>
                    <p class="avatar-name mt-2 mb-0 ml-2">
                        Paul Smith
                    </p>
                    <span class="ml-2">Founder @ B2S Plumbing</span>
                </div>
            </div>

            <div class="reg-img">
                <img
                :src="$root.serverBasePath + '/register.png'"
                alt="Strata Connex"
                class="img-fluid"
            />
            </div>
        </div>                
    </div>
</template>

<script>
import FooterComponent from "../includes/FooterComponent.vue";


export default {
    components: {
    FooterComponent
  }
};
</script>


<style scoped>
@media screen and (max-width: 991px) {
    .reg-img {
        display: flex;
        justify-content: center;
    }

    br {
        display: none;
    }
}


@media screen and (min-width: 992px) {
    .reg-img {
        max-width: 420px;
    }
}

@media screen and (min-width: 801px) and (max-width: 1200px) {
    br {
        display: none;
    }

    .reg-img {
        width: 100%;
        /* margin-left: 25px; */
        height: auto;
    }
}

</style>